import { useState } from 'react';
import { price as priceUtils } from '@eti/utils';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { breakpoints } from '@etg/wings';
import { ConnectedSelectBox } from '@eti/form';
import { onMealChange, handleSendAddToCartEvent, getMinMealPrice } from '../utils/mealUtil';
import { useProductSnowplowTracking } from '../../custom-hooks/useProductSnowplowTracking';
import { jsx as _jsx } from "react/jsx-runtime";
const dropDownStyles = css`
  width: 100%;

  @media (min-width: ${breakpoints._768}) {
    max-width: 484px;
    width: 303px;
  }

  label {
    margin-inline-start: 0;
  }
`;
const placeholderStyles = css`
  color: #737373;
`;
const formatSelectedOption = (selectedOptions, placeholder, travelerIndex) => {
  var _selectedOption$label;
  const selectedOption = selectedOptions.find(meal => meal.travelerId === travelerIndex);
  const label = (_selectedOption$label = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) !== null && _selectedOption$label !== void 0 ? _selectedOption$label : placeholder;
  return /*#__PURE__*/_jsx("p", {
    className: !selectedOption ? placeholderStyles : '',
    children: label
  });
};
const MealDropdown = ({
  mealPreferences,
  productName,
  productPosition,
  currentTravelerId,
  mealState,
  rootElement
}) => {
  const {
    t
  } = useTranslation();
  const {
    sendAddToCartEvent,
    updateContext
  } = useProductSnowplowTracking(productName, {
    rootElement,
    productPosition,
    sendSeenEvent: false
  });
  const [selectedMeals, setSelectedMeal] = useState([]);
  const selectedMealOption = mealState.length ? mealState.find(meal => (meal === null || meal === void 0 ? void 0 : meal.travelerId) === currentTravelerId) : selectedMeals.find(meal => (meal === null || meal === void 0 ? void 0 : meal.travelerId) === currentTravelerId);
  const placeholder = t('Product.Meal.Dropdown.Placeholder');
  return /*#__PURE__*/_jsx(ConnectedSelectBox, {
    className: dropDownStyles,
    "data-testid": `${productName}-dropdown-${currentTravelerId}`,
    formatSelectedOption: val => formatSelectedOption(val, placeholder, currentTravelerId),
    label: t('Product.Meal.Dropdown.Label'),
    name: `${productName}.dropdowns`,
    normalize: selectedMealValue => {
      if (selectedMealValue) {
        var _selectedMealOption$p;
        const meals = onMealChange(selectedMealValue, mealState, currentTravelerId);
        setSelectedMeal(meals);
        handleSendAddToCartEvent(selectedMealValue, (_selectedMealOption$p = selectedMealOption === null || selectedMealOption === void 0 ? void 0 : selectedMealOption.price) !== null && _selectedMealOption$p !== void 0 ? _selectedMealOption$p : priceUtils.formatPrice(getMinMealPrice(mealPreferences)), sendAddToCartEvent, updateContext);
        return meals;
      }
    },
    options: mealPreferences,
    placeholder: placeholder,
    value: selectedMealOption || ''
  });
};
export default MealDropdown;
//# sourceMappingURL=MealDropdown.js.map